import { ComponentWithApplyButtonInterface } from 'domains/job-detail/application/interfaces';
import { useTranslation } from 'next-i18next/pages';

import { CareType } from '@pflegia/types/api/employer/care-type';
import SimpleCard from '@pflegia/ui/shared/simple-card';

import OffersDialogueButton from '@shared/components/dialogue';
import { useRouterHelper } from '@shared/hooks/use-router-helper';

import ClientAssignmentItem from './ClientAssignmentItem.component';

export interface ClientAssignmentType extends ComponentWithApplyButtonInterface {
  typesLeasingEmployer?: CareType[];
  employerName: string;
  slug: string;
}

const ClientAssignment: React.FC<ClientAssignmentType> = ({
  jobPositionId,
  openDialog,
  status,
  title,
  slug,
  type,
  employerName,
  typesLeasingEmployer = [],
}) => {
  const { isExternalJob } = useRouterHelper();
  const { t } = useTranslation('jobDetails', { keyPrefix: 'clientAssignment' });

  return (
    <div className='rounded-2xl bg-white p-6 pt-4 md:p-12'>
      <h4 className='font-handwriting text-main-blue mb-6 text-2xl md:text-3xl'>{t('title')}</h4>

      <div className='flex flex-col gap-6 py-2 md:flex-row md:flex-wrap'>
        {typesLeasingEmployer.map(item => (
          <SimpleCard className='flex flex-row items-center p-4' key={item}>
            <ClientAssignmentItem label={item} />
          </SimpleCard>
        ))}
      </div>

      {type === 'default' && !isExternalJob && (
        <OffersDialogueButton
          employerName={employerName}
          jobPositionId={jobPositionId}
          status={status}
          jobTitle={title}
          label={t('getInTouch')}
          className='mt-4 w-full sm:block md:mt-6 md:ml-auto md:w-[300px]'
          openDialog={openDialog}
          slug={slug}
        />
      )}
    </div>
  );
};

export default ClientAssignment;
